var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7764 3.66504C17.6562 3.66504 21.6113 7.62013 21.6113 12.5C21.6113 17.3799 17.6562 21.335 12.7764 21.335C7.89649 21.335 3.94141 17.3799 3.94141 12.5C3.94141 7.62013 7.89649 3.66504 12.7764 3.66504ZM12.7764 4.83496C8.54374 4.83496 5.11133 8.26737 5.11133 12.5C5.11133 16.7326 8.54374 20.165 12.7764 20.165C17.009 20.165 20.4414 16.7326 20.4414 12.5C20.4414 8.26737 17.009 4.83496 12.7764 4.83496ZM12.7812 7.50879C12.939 7.50433 13.087 7.5458 13.1914 7.62598C13.2908 7.70239 13.3613 7.82095 13.3613 8V12.665H18.0264C18.577 12.665 18.7988 12.982 18.7988 13.25C18.7988 13.518 18.577 13.835 18.0264 13.835H12.1914V8C12.1914 7.84732 12.2583 7.7321 12.3633 7.64941C12.4719 7.56392 12.6235 7.51328 12.7812 7.50879Z",
    fill: "#4F5660",
    stroke: "#4F5660",
    strokeWidth: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeClock);
export default __webpack_public_path__ + "static/media/homeClock.7926637aba33a39ef1ac5df466b838e8.svg";
export { ForwardRef as ReactComponent };